import { render, staticRenderFns } from "./AppSaFooter.vue?vue&type=template&id=0abc0e6a&lang=pug&"
import script from "./AppSaFooter.vue?vue&type=script&lang=js&"
export * from "./AppSaFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports